<template>
    <div>
        <el-form :inline="true" :model="query" class="query-form" size="mini">

            <el-form-item>
                <el-button-group>
                    <el-button type="primary" icon="el-icon-refresh" @click="onReset"></el-button>
                    <el-button type="primary" v-if="authRulesFun('admin/auth/permission_rule/save')"  @click.native="handleForm(null,null)">Add</el-button>
                </el-button-group>
            </el-form-item>
        </el-form>

        <el-tree
            :data="mergeList"
            :props="defaultProps"
            node-key="id"
            default-expand-all
            :expand-on-click-node="false"
            :render-content="renderContent">
        </el-tree>

        <!--form-->
        <el-dialog
            :title="formMap[formName]"
            :visible.sync="formVisible"
            :before-close="hideForm"
            width="85%"
            top="5vh">
            <el-form :model="formData" :rules="formRules" ref="dataForm">
                <el-form-item label="Rule Name" prop="name">
                    <el-input type="" maxlength="60" v-model.trim="formData.name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Rule Title" prop="title">
                    <el-input type="" maxlength="60" v-model.trim="formData.title" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Status" prop="status">
                    <el-radio-group v-model="formData.status">
                        <el-radio :label="0">Disable</el-radio>
                        <el-radio :label="1">Normal</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Additional Regular Expressions">
                    <el-input type="textarea" maxlength="30"  v-model="formData.condition"></el-input>
                </el-form-item>
                <el-form-item label="Sort" prop="listorder">
                    <el-input type="" maxlength="20" v-model="formData.listorder" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="hideForm">Cancel</el-button>
                <el-button type="primary" @click.native="formSubmit()" :loading="formLoading">Save</el-button>
            </div>
        </el-dialog>
    </div>

</template>

<script>
import {
    authPermissionRuleList,
    authPermissionRuleSave,
    authPermissionRuleDelete
} from "../../../api/auth/authPermissionRule";
const formJson = {
    id: "",
    pid: 0,
    name: "",
    title: "",
    status: 1,
    condition: "",
    listorder: 50
};
export default {
    data() {
        var validatorSort = (rule, value, callback) => {
            var reg = /^[0-9]*$/;
            if(!reg.test(value)){
                callback(new Error('Sort must be a numeric value'));
            }else if (value>1000) {
                callback(new Error('Max 1000'));
            } else {
                callback();
            }
        };
        return {
            authRules:this.$store.state.admin.authRules,
            query: {
                // pid: '',
            },
            mergeList: [],
            node: null,
            defaultProps: {
                children: "children",
                label: "title"
            },
            treeList: [],
            loading: true,
            index: null,
            formName: null,
            formMap: {
                Add: "Add",
                Edit: "Edit"
            },
            formLoading: false,
            formVisible: false,
            formData: formJson,
            formRules: {
                name: [
                    { required: true, message: "Please enter a rule name", trigger: "blur" }
                ],
                listorder:[
                    { type: 'number', validator:validatorSort, trigger: "change"},
                ],
                title: [
                    { required: true, message: "Please enter a title", trigger: "blur" }
                ],
                status: [
                    { required: true, message: "Please select a status", trigger: "change" }
                ]
            },
            pidData: {},
            deleteLoading: false
        };
    },
    methods: {
        authRulesFun(url){
            if(this.authRules.length==1 && this.authRules[0]=='admin'){
                return true
            }
            var status = false
            for(var a=0;a<this.authRules.length;a++){
                if(this.authRules[a]==url){
                    status = true
                    break;
                }else {
                    status = false
                }
            }
            return status
        },
        /*eslint-disable */
        renderContent (h, { node, data, store }) {
            return (
                <span style="flex: 1; display: flex; align-items: center; justify-content: space-between; font-size: 14px; padding-right: 8px;">
                <span>
                <span title={ data.name }>{node.label}</span>
            </span>
            <span>
                <el-button style="font-size: 12px;" type="text" v-show={this.authRulesFun('admin/auth/permission_rule/save')}  on-click={ () => this.handleForm(node, data, 'Add') }>Add Submenu</el-button>
                <el-button style="font-size: 12px;" type="text" v-show={this.authRulesFun('admin/auth/permission_rule/edit')}  on-click={ () => this.handleForm(node, data, 'Edit') }>Edit</el-button>
                <el-button style="font-size: 12px;" type="text" v-show={this.authRulesFun('admin/auth/permission_rule/delete')} on-click={ () => this.handleDel(node, data) }>Delete</el-button>
            </span>
            </span>)
        },
        onReset() {
            this.$router.push({
                path: ""
            });
            this.query = {
                name: "",
                status: ""
            };
            this.getList();
        },
        onSubmit() {
            this.getList();
        },
        getList() {
            this.loading = true;
            authPermissionRuleList(this.query)
                .then(response => {
                    this.loading = false;
                    if (response.code) {
                        this.$message.error(response.message);
                    }
                    if(response.data.list.length>0){
                        this.mergeList = response.data.list
                    }else{
                        this.mergeList = [];
                    }

                })
                .catch(() => {
                    this.loading = false;
                    // this.mergeList = [];
                });
        },
        // updata form
        resetForm() {
            if (this.$refs["dataForm"]) {
                // clean form
                this.$refs["dataForm"].clearValidate();
                // updata form
                this.$refs["dataForm"].resetFields();
            }
        },
        // hide form
        hideForm() {
            // update value
            this.formVisible = !this.formVisible;
            return true;
        },
        // show form
        handleForm(node, data, formName) {
            this.formVisible = true;
            this.pidData = data || null;

            formJson.pid = (data && parseInt(data.id)) || 0;
            this.formData = JSON.parse(JSON.stringify(formJson));
            if (formName === "Edit") {
                this.formData = Object.assign({}, data);
                this.node = node;
            }
            this.formName = formName;
            if (data && data.id) {
                this.index = this.mergeList.findIndex(d => d.id === data.id);
            }
        },
        formSubmit() {
            this.$refs["dataForm"].validate(valid => {
                if (valid) {
                    this.formLoading = true;
                    let data = Object.assign({}, this.formData);
                    authPermissionRuleSave(data, this.formName)
                        .then(response => {
                            this.formLoading = false;
                            if (response.code) {
                                this.$message.error(response.message);
                                return false;
                            }
                            this.$message.success("Successfully");
                            this.formVisible = false;
                            if (this.formName !== "Edit") {
                                if (response.data && response.data.id) {
                                    data.id = response.data.id;
                                    if (this.pidData) {
                                        if (!this.pidData.children) {
                                            this.$set(
                                                this.pidData,
                                                "children",
                                                []
                                            );
                                        }
                                        this.pidData.children.push(data);
                                    } else {
                                        this.mergeList.push(data);
                                    }
                                }
                            } else {
                                const parent = this.node.parent;
                                const children =
                                    parent.data.children || parent.data;
                                const index = children.findIndex(
                                    d => d.id === data.id
                                );
                                children.splice(index, 1, data);
                            }
                            // updata form
                            this.resetForm();
                            this.onReset();
                        })
                        .catch(() => {
                            this.formLoading = false;
                        });
                }
            });
        },
        // delete
        handleDel(node, data) {
            if (data.children && data.children.length > 0) {
                // this.$alert("Please delete the submenu first", "Tips", {
                //     confirmButtonText: "OK"
                // });
                this.$message.error("Please delete the submenu first");
                return false;
            }
            if (data.id) {
                this.$confirm("Are you sure to delete this record?", "Tips", {
                    type: "warning"
                })
                    .then(() => {
                        this.deleteLoading = true;
                        let para = { id: data.id };
                        authPermissionRuleDelete(para)
                            .then(response => {
                                this.deleteLoading = false;
                                if (response.code) {
                                    this.$message.error(response.message);
                                    return false;
                                }
                                this.$message.success("Successfully");
                                const parent = node.parent;
                                const children =
                                    parent.data.children || parent.data;
                                const index = children.findIndex(
                                    d => d.id === data.id
                                );
                                children.splice(index, 1);
                            })
                            .catch(() => {
                                this.deleteLoading = false;
                            });
                    })
                    .catch(() => {
//                        this.$message.error("Cancel");
                    });
            }
        }
    },
    filters: {
        statusFilterType(status) {
            const statusMap = {
                0: "gray",
                1: "success"
            };
            return statusMap[status];
        },
        statusFilterName(status) {
            const statusMap = {
                0: "Disable",
                1: "Normal"
            };
            return statusMap[status];
        }
    },
    mounted() {},
    created() {
        this.getList();
    }
};
</script>

<style type="text/scss" lang="scss">
</style>
